<template>
  <div class="site-wrap">
    <el-card>
      <el-tabs v-model="activeTab">
        <template v-for="(item, index) in tabs">
          <el-tab-pane
            :label="item.label"
            :name="item.name"
            :key="index"
            v-if="authList.includes(item.auth)"
          ></el-tab-pane>
        </template>
      </el-tabs>
    </el-card>
    <div class="search-wrap">
      <Prop v-if="activeTab === '1'"></Prop>
      <Category v-if="activeTab === '2'"></Category>
      <Tag v-if="activeTab === '3'"></Tag>
    </div>
  </div>
</template>

<script>
import Category from '../category'
import Prop from '../prop'
import Tag from '../tag'
export default {
  components: { Category, Prop, Tag },
  data() {
    return {
      activeTab: null,
      tabs: [
        {
          label: this.$t('product-manager::tabs_prop'),
          name: '1',
          auth: 'shop-management::stores::product-manager::attr'
        },
        {
          label: this.$t('product-manager::tabs_category'),
          name: '2',
          auth: 'shop-management::stores::product-manager::cate'
        },
        {
          label: this.$t('product-manager::tabs_tag'),
          name: '3',
          auth: 'shop-management::stores::product-manager::tag'
        }
      ]
    }
  },
  created() {
    if (this.authPromise('stores::product-manager::tag')) {
      this.activeTab = '3'
    }
    if (this.authPromise('stores::product-manager::cate')) {
      this.activeTab = '2'
    }
    if (this.authPromise('stores::product-manager::attr')) {
      this.activeTab = '1'
    }
  }
}
</script>

<style lang="scss" scoped>
.site-wrap {
  .search-wrap {
    margin-top: -30px;
  }
}
</style>
